<section class="grid gap-4">
  <div class="flex flex-wrap items-center justify-between gap-3">
    <page-title [title]="'Create client'"></page-title>
    <a mat-stroked-button routerLink="/clients">Back to list</a>
  </div>

  <client-form
    title="Create new client"
    submitLabel="Create"
    [busy]="clientStore.saving()"
    (submitted)="onSubmit($event)" />
</section>
